import { LOYALTY_CONTENT_ACTION_TYPE } from "./loyalty-content.action";

export const loyaltyContentMessageContext = {
	getMemberLevels: LOYALTY_CONTENT_ACTION_TYPE.getMemberLevels,
	getEarnPoints: LOYALTY_CONTENT_ACTION_TYPE.getEarnPoints,
};
